import React from 'react';
import button from "bootstrap/js/src/button";

const Button = (props) => {
    const {
        label       = '',
        onClick     = () => {},
        disabled    = false,
        inverse     = false,
    } = props;

    return (
        <button onClick={() => onClick()}
                disabled={disabled}
                className={!inverse ? 'button' : 'button inverse'}
        >
            <span>{label}</span>
        </button>
    )
}

export default Button;
